import { boxValorStyles } from './BoxValor.style'

export function boxValorIO() {
  return {
    styles: boxValorStyles
  }
}

export type BoxValorIO = ReturnType<typeof boxValorIO>
